import { render, staticRenderFns } from "./CardDetailItem.vue?vue&type=template&id=47ebd8df"
import script from "./CardDetailItem.vue?vue&type=script&lang=js"
export * from "./CardDetailItem.vue?vue&type=script&lang=js"
import style0 from "./CardDetailItem.vue?vue&type=style&index=0&id=47ebd8df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports